<template>
  <v-col
    v-bind="{ ...containerProps, ...containerOptions }"
  >
    <v-checkbox
      v-model="modelValue"
      v-bind="$attrs"
      :color="colors.base"
      :label="label"
      false-value="Ei"
      true-value="Kyllä"
      hide-details
    >
      <template #label>
        <div class="text-body-2">
          <b :class="colors.text">{{ chapter }}</b>
          {{ $attrs.label }}
        </div>
      </template>
    </v-checkbox>
  </v-col>
</template>

<script>
import { EventBus } from '@/utils';

export default {
  name: 'HelmiCheckbox',

  inheritAttrs: false,

  props: {
    chapter: {
      type: String,
      default: '',
    },

    colors: {
      type: Object,
      default: () => ({
        base: 'primary',
        text: 'primary--text',
      }),
    },

    containerProps: {
      type: Object,
      default: () => ({}),
    },

    containerOptions: {
      type: Object,
      default: () => ({}),
    },

    propertyValue: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    modelValue: '',
    defaultValue: 'Ei',
  }),

  computed: {
    label() {
      return `${this.chapter} ${this.$attrs.label}`;
    },
  },

  watch: {
    // Handles internal model changes.
    modelValue(newVal) {
      this.$emit('input', newVal);
      this.$emit('evaluate', newVal, this.$attrs.id);
    },

    // Handles external model changes.
    '$attrs.value': {
      handler(val) {
        this.modelValue = val === '' ? 'Ei' : val;
      },
      immediate: true,
    },
  },

  mounted() {
    EventBus.$on('FORM_RESET', this.resetValue);
  },

  methods: {
    resetValue() {
      this.modelValue = this.propertyValue || this.defaultValue;
    },
  },
};
</script>
